module.exports = __webpack_public_path__ + "static/media/英特药业.ba834ac7.png";